import React from 'react';
import * as S from './styles';

type ToggleOptionProps = {
  selected: boolean;
  children: React.ReactNode;
};

const ToggleOption: React.FC<ToggleOptionProps> = (props) => {
  const { children, selected } = props;

  return <S.Toggle $selected={selected}>{children}</S.Toggle>;
};
export default ToggleOption;
